export default "__VITE_ASSET__ryAPW4pX__"